import React from "react";
import CompanyNewsEditable from "./CompanyNewsEditable";
import CompanyNewsNonEditable from "./CompanyNewsNonEditable";
import { HomePageView } from "../types";
var CompanyNews = function (_a) {
    var companyNews = _a.companyNews, id = _a.id, isOnHover = _a.isOnHover, pageView = _a.pageView, isAdmin = _a.isAdmin, openModal = _a.openModal;
    if (pageView === HomePageView.EMPLOYEE_VIEW || isAdmin) {
        return React.createElement(CompanyNewsNonEditable, { isAdmin: isAdmin, id: id, companyNews: companyNews, pageView: pageView });
    }
    return React.createElement(CompanyNewsEditable, { id: id, companyNews: companyNews, pageView: pageView, isOnHover: isOnHover, openModal: openModal });
};
export default CompanyNews;
